import { useSelector } from 'react-redux';
import { APPLICATION_TYPE } from '../constants/sessionStorage';
import { selectApplication } from '../store/selectors/applicationSelectors';
import { APPLICANT_TYPES, APPLICATION_TYPE_STRING } from '../util/constants';
import { retrieveFromSessionStorage } from '../util/helpers/sessionStorageHelper';

const getOwnerData = (ApplicantData) => {
  if (!ApplicantData) {
    return {};
  }

  const { Owner } = ApplicantData;

  return Owner;
};

const getPrimaryHolderData = (ApplicantData) => {
  if (!ApplicantData) {
    return {};
  }

  const { PrimaryHolder } = ApplicantData;

  return PrimaryHolder;
};

const getSecondaryHolderData = (ApplicantData) => {
  if (!ApplicantData) {
    return {};
  }

  const { SecondaryHolder } = ApplicantData;

  return SecondaryHolder;
};

const getAuthorizedAgentData = (ApplicantData) => {
  if (!ApplicantData) {
    return {};
  }

  const { AuthorizedAgent } = ApplicantData;

  return AuthorizedAgent;
};

const getCustodianData = (ApplicantData) => {
  if (!ApplicantData) {
    return {};
  }

  const { Custodian } = ApplicantData;

  return Custodian;
};

const getMinorData = (ApplicantData) => {
  if (!ApplicantData) {
    return {};
  }

  const { Minor } = ApplicantData;

  return Minor;
};

const getLegalEntityData = (ApplicantData) => {
  if (!ApplicantData) {
    return {};
  }

  const { LegalEntity } = ApplicantData;

  return LegalEntity;
};

export const useApplicantData = (applicantType) => {
  const ApplicationType = retrieveFromSessionStorage(APPLICATION_TYPE);
  const Application = useSelector(selectApplication);
  const AccountData = Application[ApplicationType];

  if (!AccountData) {
    return {};
  }

  if (ApplicationType === APPLICATION_TYPE_STRING[5]) {
    if (applicantType === APPLICANT_TYPES.MINOR) {
      return getMinorData(AccountData);
    }
    return getCustodianData(AccountData);
  }

  if (
    applicantType === APPLICANT_TYPES.MAIN &&
    ApplicationType === APPLICATION_TYPE_STRING[5]
  ) {
    return getCustodianData(AccountData);
  }

  if (
    (ApplicationType === APPLICATION_TYPE_STRING[2] &&
      applicantType === APPLICANT_TYPES.BUSINESS) ||
    (ApplicationType === APPLICATION_TYPE_STRING[2] &&
      applicantType === APPLICANT_TYPES.SECONDARY)
  ) {
    return getLegalEntityData(AccountData);
  }

  if (ApplicationType === APPLICATION_TYPE_STRING[2]) {
    return getAuthorizedAgentData(AccountData);
  }

  if (
    applicantType === APPLICANT_TYPES.SECONDARY &&
    ApplicationType === APPLICATION_TYPE_STRING[4]
  ) {
    return getSecondaryHolderData(AccountData);
  }

  if (ApplicationType === APPLICATION_TYPE_STRING[4]) {
    return getPrimaryHolderData(AccountData);
  }

  if (
    applicantType === APPLICANT_TYPES.SECONDARY &&
    (ApplicationType !== APPLICATION_TYPE_STRING[4] ||
      ApplicationType !== APPLICATION_TYPE_STRING[5])
  ) {
    return;
  }

  return getOwnerData(AccountData);
};
